<template>
  <div class="entry-view d-flex align-items-center justify-content-center min-vh-100">
    <p class="text-muted">Memuat...</p>
  </div>
</template>

<script>
import { savePersonal, ensureClientProfile } from "@/utils/pesanan";

export default {
  name: 'EntryView',
  async mounted() {
    const { clientToken, meja } = this.$route.params;
    const orderType = (meja != null && meja !== '') ? 'dine_in' : 'take_away';
    savePersonal({
      clientToken: clientToken || '',
      meja: meja || null,
      tableId: null,
      clientId: /^\d+$/.test(String(clientToken || '').trim()) ? Number(clientToken) : null,
      orderType,
      clientName: '',
      logo: '',
    });
    await ensureClientProfile({ force: true });
    this.$router.replace('/');
  }
};
</script>
